/* ============================================================
   INDIGREY REDESIGN — WISHLIST page hydration

   Saved handles live in localStorage, so the cards are fetched from
   Shopify's Section Rendering API and rendered SERVER-SIDE by the real
   `indigrey-rd-card` snippet. That keeps the craft eyebrow, colourways,
   prices and size picker identical to the catalogue — a client-built card
   cannot read metafields and previously degraded to product.type.

   Card behaviour (swipe / quick-add / hearts / adaptive icons) is handled by
   the shared IG + collection runtimes once the markup is in the DOM.
   ============================================================ */
(function () {
  var page = document.querySelector('[data-ig-wishlist-page]');
  if (!page) return;
  var grid = page.querySelector('[data-ig-wishlist-grid]');
  var empty = page.querySelector('[data-ig-wishlist-empty]');
  var countEl = page.querySelector('[data-wishlist-count]');
  // The grid lives inside a wrapper that ships hidden. It must be revealed once
  // cards actually render (and re-hidden when the wishlist empties) — otherwise
  // the populated grid stays invisible and only "You May Also Like" shows. This
  // reveal step was missing, which is why saved pieces never appeared.
  var strip = page.querySelector('[data-ig-wish-strip]');
  function showStrip(on) { if (strip) strip.hidden = !on; }

  // Section Rendering needs the FULL runtime section id
  // (e.g. "template--123__wishlist-cards"), not the template key — so read it
  // off the rendered wrapper rather than hardcoding.
  function sectionId() {
    var el = document.querySelector('[data-ig-wishlist-cards]');
    var wrap = el && el.closest ? el.closest('[id^="shopify-section-"]') : null;
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }

  function handles() { return (window.Wishlist && window.Wishlist.get()) || []; }

  function showEmpty(on) { if (empty) empty.hidden = !on; }

  function render() {
    var list = handles();
    if (countEl) countEl.textContent = list.length;
    if (!list.length) { grid.innerHTML = ''; showStrip(false); showEmpty(true); return; }
    showEmpty(false);

    var sid = sectionId();
    if (!sid) { showStrip(false); showEmpty(true); return; }
    var url = '/pages/wishlist?section_id=' + encodeURIComponent(sid) +
              '&handles=' + list.slice(0, 20).map(encodeURIComponent).join(',');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelector('[data-ig-wishlist-cards]');
        if (!cards || !cards.querySelector('.ig-rd-card')) { grid.innerHTML = ''; showStrip(false); showEmpty(true); return; }
        grid.innerHTML = cards.innerHTML;
        showStrip(true);            // reveal the populated grid — the missing step
        showEmpty(false);
        document.dispatchEvent(new CustomEvent('ig-rd:grid-updated'));
      })
      .catch(function () { grid.innerHTML = ''; showStrip(false); showEmpty(true); });
  }

  // Prune when an item leaves the wishlist (un-hearted or moved to the bag).
  // Only the affected card is dropped — it fades, the grid FLIPs the survivors
  // into place, and the viewport is held by the shared IG helper. No refetch,
  // no full re-render of the grid.
  document.addEventListener('wishlist:updated', function () {
    var saved = handles();
    if (countEl) countEl.textContent = saved.length;
    var gone = [].slice.call(grid.querySelectorAll('.ig-rd-card[data-product-handle]'))
      .filter(function (c) { return saved.indexOf(c.getAttribute('data-product-handle')) < 0; });
    if (!gone.length) return;
    var pending = gone.length;
    gone.forEach(function (c) {
      var after = function () { if (--pending === 0 && !grid.querySelector('.ig-rd-card')) { showStrip(false); showEmpty(true); } };
      if (window.IG && IG.dropCard) IG.dropCard(c, after);
      else { if (c.parentNode) c.parentNode.removeChild(c); after(); }
    });
  });

  // window.Wishlist is a deferred <body> script and runs after this one.
  function boot() {
    var tries = 0;
    (function wait() {
      if (window.Wishlist) return render();
      if (tries++ > 100) return render();
      setTimeout(wait, 50);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
